import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import RouterPaths from '../../constants/RouterPaths';

export default function useIsAuthenticated() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isAuthenticated = useSelector((state) => state.auth.get('isAuthenticated'));
  const isSeller = useSelector((state) => state.auth.get('isSeller'));
  const isBuyer = useSelector((state) => state.auth.get('isBuyer'));
  const location = useLocation();
  const [from, setFrom] = useState('');
  useEffect(() => {
    const redirectTo = location?.state?.from;
    if (redirectTo) setFrom(redirectTo);
  }, [location]);

  useEffect(() => {
    if (isAuthenticated) {
      if (from) {
        navigate(from, { replace: true, state: null });
      } else {
        navigate(RouterPaths.SEARCH);
      }
    } else {
      navigate(RouterPaths.LOGIN, { replace: true });
    }
  }, [isAuthenticated, dispatch, isSeller, isBuyer, navigate, from]);
}
